<template>
    <b-modal ref="mdlDeviceEdit" size="xl" :title="titoloModale" no-close-on-backdrop no-close-on-esc centered scrollable>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Imei</span>
                    <b-form-input v-model="jsonDataDevice.imeii" placeholder="Imei...."> </b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Sistema operativo</span>
                    <b-form-input v-model="jsonDataDevice.sistemaOperativo" placeholder="Sistema operativo...."> </b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Tipo</span>
                    <b-form-input v-model="jsonDataDevice.tipo" placeholder="Tipo...."> </b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Stato attuale</span>
                    <b-form-select v-model="jsonDataDevice.statoAttuale" :options="statoAttualeOptions" value-field="stato" text-field="stato"></b-form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <span class="sa-label-data">Password</span>
                    <b-form-input v-model="jsonDataDevice.password" placeholder="Password...."> </b-form-input>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-button size="md" variant="outline-secondary" @click="onClickIndietro"> Annulla </b-button>

            <!--<b-button size="md" variant="outline-danger" @click="onClickAnnulla"> Annulla </b-button>-->

            <b-button variant="outline-success" @click="onSalvaDevice"> Salva Device </b-button>
        </template>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    name: "ConfigurazioneDeviceModalEditComponent",

    data() {
        return {
            titoloModale: "Modifica Device",
            jsonDataDevice: {
                id: "",
                imeii: "",
                sistemaOperativo: "",
                tipo: "",
                statoAttuale: null,
                password: "",
            },
            pathResource: "/devicedevice",
            pathResourceStati: "/devicestati",
            statoAttualeOptions: [{ text: "-seleziona stato -", stato: null }],
        };
    },
    mounted() {
        let me = this;
        me.loadDataOptionsStatoAttuale();
    },
    methods: {
        show(item) {
            let data = item
                ? Object.assign({}, item)
                : {
                      id: "-1",
                      imeii: "",
                      sistemaOperativo: "",
                      tipo: "",
                      statoAttuale: "",
                      password: "",
                      statoAttualeDataOra: "",
                  };
            this.jsonDataDevice = data;
            this.titoloModale = data.id === "-1" ? "Nuovo Device" : "Modifica Device";
            if (data.id === "-1" && this.statoAttualeOptions.length > 0) {
                this.jsonDataDevice.statoAttuale = this.statoAttualeOptions[0].stato;
            }
            this.$refs.mdlDeviceEdit.show();
        },
        onClickIndietro() {
            this.$refs.mdlDeviceEdit.hide();
        },
        onSalvaDevice() {
            let me = this;
            me.jsonDataDevice.statoAttualeDataOra = new Date().getTime();
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataDevice, me.loadDataDeviceSuccess, me.loadDataDeviceError);
        },
        loadDataDeviceSuccess() {
            this.$bvModal.msgBoxOk("Device salvato con successo.", {
                title: "Salvataggio completato",
                size: "sm",
                okVariant: "success",
                centered: true,
            });
            this.$refs.mdlDeviceEdit.hide();
            this.$emit("afterSave");
        },
        loadDataDeviceError(error) {
            console.log("Errore nel salvataggio della voce menu:", error.response.data.messaggio);
        },
        loadDataOptionsStatoAttuale() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStati, {}, me.loadDataStatiSuccess, me.loadDataStatiError);
        },
        loadDataStatiSuccess(response) {
            let me = this;
            me.statoAttualeOptions = response.data.data.list;
        },
        loadDataStatiError(error) {
            console.log(error);
        },
    },
};
</script>
